import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import { useGlobalDispatch } from '../components/Context/globalContext';


export default (props) => {
  const globalDispatch = useGlobalDispatch();
  
  useEffect(() => {
    globalDispatch({type: 'meta', payload: {pageTitle: props.data.allCommerceStoreBoutique.nodes[0].name + '- Exchange & Return Policy'}});
  }, []);

  return (
    <Layout>
      <div className="sta-basic-page">
        <h2 className="page-title">{props.data.allCommerceStoreBoutique.nodes[0].name} - Exchange & Return Policy</h2>
        {(() => {
          if (props.data.allCommerceStoreBoutique.nodes[0].field_exhange_policy) {
            return (
              ReactHtmlParser(props.data.allCommerceStoreBoutique.nodes[0].field_exhange_policy.processed)
            );
          }
        })()}
      </div>
    </Layout>
  )
};


export const PolicyQuery = graphql`
  query($boutiqueId: String!){
    allCommerceStoreBoutique(filter: {drupal_id: {eq: $boutiqueId}}) {
      nodes {
        name
        drupal_id
        path {
          alias
        }
        field_exhange_policy {
          processed
        }
      }
    }
}`;
